import * as React from "react";
import {FormBuilderOptions} from "./FormBuilder.options";
import {TotalContainer} from "./TotalContainer";
import {NumericUtilities} from "../Utilities/NumericUtilities";
import {FBFieldBaseOptions, FieldTypeEnum} from "../Fields/Core/FBFieldBase.options";

import 'shared/styles/bootstrapminimal.scss';
import {FormBuilderModel} from "FormBuilder/Core/FormBuilder.Model";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";



declare let ProductBuilderOptions:{
    Options:FormBuilderOptions,
    WCCurrency:any,
    IsVariable:string;
    Product:ProductData;
    PreviousData:any[];
    Variations:{
        Attributes:any;
        Variations:{
            price:string;
            variation_id:string;
            sale_price:string;
        }[]
    }
};

export class FormBuilder extends React.Component<FormBuilderProps, {}> {

    static defaultProps: Partial<FormBuilderProps> = {};
    Rows:FBRowModel[];
    Container:HTMLDListElement;
    FormContainer:HTMLFontElement;
    SerializedInput:HTMLInputElement;

    QuantitySelectors="input.qty,input[name='quantity']";



    public Model:FormBuilderModel;
    constructor(props: FormBuilderProps) {
        super(props);
        this.InitializeLocalization();
        this.Model=this.props.Model;


    }



    componentWillUnmount(): void {
        this.Model.OnRefresh.Unsubscribe(this);
    }

    componentDidMount(): void {
        this.Model.OnRefresh.Subscribe(this,()=>this.forceUpdate());
        this.FormContainer=null;
        let currentContainer=this.Container;
        while(currentContainer!=null)
        {
            if(currentContainer.tagName=='FORM') {
                this.FormContainer=currentContainer as any;
                break;
            }

            currentContainer=currentContainer.parentNode as any;
        }

        if(this.FormContainer==null)
            return;



        if(this.props.PreviousData!=null&&this.props.PreviousData.Quantity!=null)
        {
            let input=this.FormContainer.querySelector('input.qty') as HTMLInputElement;
            if(input!=null){
                input.value=this.props.PreviousData.Quantity;
            }
        }

        let item=this.FormContainer.querySelector(this.QuantitySelectors) as HTMLInputElement;
        if(item!=null)
        {
            this.Model.PriceManager.UpdateQuantity(NumericUtilities.ParseNumber(item.value));
            item.addEventListener('input',(e)=>{this.Model.PriceManager.UpdateQuantity(NumericUtilities.ParseNumber(item.value,0))});
        }

        this.Model.OnLoad.Publish();
        this.MaybeInitializeVariationFields();

        this.MonitorFormSubmission();
        this.Model.IsLoaded=true;
    }

    public GetFields():FBFieldBaseModel[]{
        return this.Model.ContainerManager.GetFields();
    }



    public render() {
        return (
            <div className={'rednaoExtraProductForm rednao'} ref={x=>this.Container=x as any}>
                <style type={'text/css'}>
                    {this.props.Model.Options.Styles}
                </style>
                <input name={'RednaoSerializedFields'} type={'hidden'} ref={x=>this.SerializedInput=x}/>
                    {this.GetRowsContainer(this.Model.Rows.map((x,index)=>
                        this.props.Model.CreateRow(x,index)
                    ))}
                {this.ShowTotal()}
            </div>
        )
    }

    public GetRowsContainer(container:any)
    {
        return (
            <div>
                {container}
            </div>
        )
    }

    public get PreviousData(){
        return this.props.PreviousData;
    }






    protected ShowTotal() {
        return(
            <TotalContainer FormBuilder={this.Model}/>
        )
    }



    protected MonitorFormSubmission() {
        this.FormContainer.addEventListener('submit',(e)=>{
            let data:any={};
            data.Fields=[];
            if(!this.Model.ContainerManager.Validate())
            {
                this.Model.ContainerManager.LastFieldWithErrors.ScrollToField();

                e.preventDefault();
            }
            for(let field of this.Model.ContainerManager.GetFields(false,false,false))
            {
                if(field.GetStoresInformation()&&field.GetIsUsed())
                    data.Fields.push(field.SerializeEntry());
            }

            data.PreviousCartKey=this.props.PreviousData!=null&&this.props.PreviousData.CartKey!=null?this.props.PreviousData.CartKey:'';
            data.Totals={};
            data.Totals.ProductPrice=this.Model.PriceManager.ProductPrice;
            data.Totals.OptionsTotal=this.Model.PriceManager.GetOptionsTotal();
            data.Totals.GrandTotal=this.Model.PriceManager.GetGrandTotal();
            data.Totals.OptionsUnitPrice=this.Model.PriceManager.GetOptionsUnitPrice();
            this.SerializedInput.value=JSON.stringify(data);
            return true;
        });
    }




    protected MaybeInitializeVariationFields() {
        if(this.Model.ProductOptions.IsVariable=='1')
        {
            let variation=document.getElementsByName('variation_id');
            if(variation.length>0)
            {
                jQuery('input.variation_id').change(()=>{
                    this.Model.ProductPriceChanged.Publish()});
            }
        }


        if(this.Model.ProductOptions.Variations==null||this.Model.ProductOptions.Variations.Attributes==null)
            return;


        for(let attributeName in this.Model.ProductOptions.Variations.Attributes)
        {
            document.querySelector('#'+attributeName.toLowerCase()).addEventListener('change',()=>{
               this.Model.VariationChanged.Publish(attributeName);
            });
        }


    }

    public get RowOptions(): FBRowModel[]{
        return this.props.Model.Rows;
    }







    Refresh() {
        this.forceUpdate();
    }

    GetRuler(): any {
        return null;
    }

    GetNextFieldId(): number {
        return 0;
    }

    DeleteField(field: FBFieldBaseModel<FBFieldBaseOptions, FBColumnModel>) {
    }

    GetRows(): FBRowModel[] {
        return this.Rows;
    }


    private InitializeLocalization() {

    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
export interface FormBuilderProps {
    Model:FormBuilderModel;
    PreviousData:any;
}

export class ProductData {
    Id:number;
    Price:number;
    SalePrice:number;
}

export interface FormBuilderState {


}